import moment from 'moment';
import getValuePropriety from 'lodash/get';
import { cloneDeep } from 'lodash';
import reseauxParametreInitializer, { reseauParametreInitializer } from '@/services/patrimoine/reseauxParametreInitializer';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import { reseauTempoExtensionInitializer } from '@/services/panier/extensionInitializer';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import customArraySort from '@/services/general/customArraySort';
import defineCenter from '@/services/general/defineCenter';
import getDispoReseauxTempo from '@/services/general/dispoReseauxTempo';
import { filtrer } from '@/services/general/listeFilter';
import { FILTRE_DYNAMIQUE_VIDE } from '@/components/creationOpportunite/configuration/filtresConf';
import GetListeElementUniqueParPropriete from '@/services/general/listeFilterDynamique';
import reseauDataPropositionInitializer from '@/services/catalogue/reseauDataPropositionInitializer';
import {
  ZOOM_DEFAULT_RESEAUX, CENTER_RESEAUX_DEFAULT, RESEAU_FROM_VENTES_RESEAUX,
  FACES_FROM_VENTES_RESEAUX, ISOCHRONE_DEFAULT, TYPE_LAYER_EMPTY,
} from '@/configuration/carteConf';
import { SELECTION, BLOQUE, OPTION } from '@/configuration/optionConf';
import gestionErreur from '@/services/general/gestionErreur';
import filterLatLng from '@/services/general/gestionLatLng';
import getFacesReseauAsync from '@/services/reseauxTempo/getFaces';
import getAnneeSemaine, { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import { browseReseaux, sendColor, getPropositions, getReseau as getReseauTempo } from '../../api/reseaux';
import * as types from './venteReseauxTempo-mutation-type';
import * as allTypes from '../mutation-type';
import store from '../store';


function initialState() {
  return {
    reseaux: [],
    reseauxWithFilter: [],
    showReseaux: false,
    address: null,
    dateDeVisualisation: new Date(),
    markersReseaux: [],
    selectedMarkerFacesDeReseaux: '',
    selectedMarkerReseaux: '',
    markersFacesParReseaux: [],
    zoomCartoReseaux: ZOOM_DEFAULT_RESEAUX,
    centerReseaux: CENTER_RESEAUX_DEFAULT,
    isochrone: ISOCHRONE_DEFAULT,
    typeLayerGeoMarketing: TYPE_LAYER_EMPTY,
    criterePlanning: {},
    dataPropositions: {},
    filtresReseaux: {},
    filtresDynamiquesReseaux: [],
    filterReseauxChanged: true,
    selectedFiltreDynamiqueReseaux: FILTRE_DYNAMIQUE_VIDE,
    avecConfreres: false,
    activeTabReseau: 2,
    zoomMarker: null,
    showReseauxSelectionne: false,
    facesReseauSelectDiapo: {},
    afficherFacesReseaux: false,
    filtreDispoReseau: [],
    dataPlanning: [],
    pointsAddress: [],
    poseOption: SELECTION,
    afficherPoi: false,
    agences: [],
    updateFiltre: null,
  };
}

const state = initialState();
let adresseReseauxTempo = null;
const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_ISOCHRONE](state, isochrone) {
    state.isochrone = isochrone;
  },
  [types.SET_FILTER_ADDRESS](state, address) {
    state.address = address;
  },
  [types.SET_TYPE_LAYER_GEO_MARKETING](state, typeLayerGeoMarketing) {
    state.typeLayerGeoMarketing = typeLayerGeoMarketing;
  },
  [types.SET_RESEAUX](state, reseaux) {
    state.reseaux = reseaux;
  },
  [types.SET_CRITERE_PLANNING_TEMPO](state, critere) {
    state.criterePlanning = critere;
  },
  [types.SET_DATA_PROPOSITION_TEMPO](state, data) {
    state.dataPropositions = data;
  },
  [types.SET_RESEAUX_WITH_FILTER](state, reseauxWithFilter) {
    state.reseauxWithFilter = reseauxWithFilter;
  },
  [types.SET_DATE_DE_VISUALISATION](state, dateDeVisualisation) {
    state.dateDeVisualisation = dateDeVisualisation;
  },
  [types.SET_SHOW_RESEAUX](state, showReseaux) {
    state.showReseaux = showReseaux;
  },
  [types.SET_MARKER_RESEAUX](state, markersReseaux) {
    state.markersReseaux = markersReseaux;
  },
  [types.SET_MARKER_FACES_DE_RESEAUX](state, markersFacesParReseaux) {
    state.markersFacesParReseaux = markersFacesParReseaux;
  },
  [types.SET_ZOOM_CARTO_RESEAUX](state, zoomCartoReseaux) {
    state.zoomCartoReseaux = zoomCartoReseaux;
  },
  [types.SET_SELECTED_MARKER_FACES_DE_RESEAUX](state, selectedMarker) {
    state.selectedMarkerFacesDeReseaux = selectedMarker;
  },
  [types.SET_SELECTED_MARKER_RESEAUX](state, selectedMarker) {
    state.selectedMarkerReseaux = selectedMarker;
  },
  [types.SET_CENTER_RESEAUX](state, center) {
    state.centerReseaux = center;
  },
  [types.SET_RESEAUX_SELECTED](state, { data, value }) {
    const reseau = state.reseaux.find((el) => { return el.num === data; });
    if (reseau) {
      reseau.selected = value;
    }
  },
  [types.TRIE_RESEAUX](state) {
    state.reseaux.sort(customArraySort(['ville', 'libelle', 'code']));
  },
  [types.SET_AVEC_CONFRERES](state) {
    state.avecConfreres = !state.avecConfreres;
  },
  [types.ADD_FILTER_DYNAMIQUE](state, value) {
    state.filtresDynamiquesReseaux.unshift(value);
  },
  [types.SET_FILTER_CHANGED](state) {
    state.filterReseauxChanged = !state.filterReseauxChanged;
  },
  [types.ADD_FILTER_PROPERTY](state, { property, valueProperty }) {
    state.filtresReseaux[property] = valueProperty;
  },
  [types.REMOVE_FILTER_PROPERTY](state, property) {
    state.filtresReseaux[property] = {};
    state.filtresDynamiquesReseaux.forEach((filtreDynamiqueReseaux) => {
      if (filtreDynamiqueReseaux.id === property) {
        state.filtresDynamiquesReseaux.splice(state.filtresDynamiquesReseaux.indexOf(
          filtreDynamiqueReseaux), 1);
      }
    });
    state.selectedFiltreDynamiqueReseaux = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.REMOVE_FILTER](state) {
    state.filtresReseaux = {};
    state.filtresDynamiquesReseaux = [];
    state.selectedFiltreDynamiqueReseaux = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.SELECT_FILTRE_DYNAMIQUE](state, filtre) {
    state.selectedFiltreDynamiqueReseaux = filtre;
  },
  [types.SET_ACTIVE_TAB_RESEAU](state, activeTabReseau) {
    state.activeTabReseau = activeTabReseau;
  },
  [types.SET_ZOOM_MARKER](state, zoomMarker) {
    state.zoomMarker = zoomMarker;
  },
  [types.SET_SHOW_RESEAUX_SELECTIONNE](state, showReseauxSelectionne) {
    state.showReseauxSelectionne = showReseauxSelectionne;
  },
  [types.SET_AFFICHER_FACES_RESEAUX](state, afficherFacesReseaux) {
    state.afficherFacesReseaux = afficherFacesReseaux;
  },
  [types.SET_FILTRE_DISPO_RESEAU](state, tableFiltre) {
    state.filtreDispoReseau = tableFiltre;
  },
  [types.SET_DATA_PLANNING](state, data) {
    state.dataPlanning = data;
  },
  [types.SET_POINTS_ADDRESS](state, pointsAddress) {
    state.pointsAddress = pointsAddress;
  },
  [types.SET_POSE_OPTION](state, value) {
    state.poseOption = value;
  },
  [types.SET_AGENCES_SELECTIONNEES](state, agences) {
    state.agences = [...agences];
  },
  [types.SET_UPDATE_FILTRE](state, updateFiltre) {
    state.updateFiltre = updateFiltre;
  },
};

const specAffichage = {
  week: {
    '1800px': {
      unit: 'weeks', size: 7, startOf: 'isoWeek',
    },
    '1600px': {
      unit: 'weeks', size: 6, startOf: 'isoWeek',
    },
    fullhd: {
      unit: 'weeks', size: 5, startOf: 'isoWeek',
    },
    'widescreen-only': {
      unit: 'weeks', size: 3, startOf: 'isoWeek',
    },
    tablet: {
      unit: 'weeks', size: 2, startOf: 'isoWeek',
    },
  },
};

const actions = {
  getReseau: async ({ getters, rootGetters }, payload) => {
    let dateDeVisualisation = moment(getters.dateDeVisualisation).format('YYYYMMDD');
    const societeId = rootGetters['user/idSociete'];
    const isAffixe2 = rootGetters['parametrage/affixe2'];
    if (payload.dateDeVisualisation) dateDeVisualisation = payload.dateDeVisualisation;
    const params = {
      datevisualisation: dateDeVisualisation,
      avecConfreres: getters.avecConfreres,
      estLc: false,
    };

    if (isAffixe2) params.societeId = societeId;
    const reseau = (await getReseauTempo(
      params,
      payload.id,
    )).data;
    reseau.selected = false;

    const alreadySelected = rootGetters['panier/reseauxTempoPanier'];
    const find = alreadySelected.find(el => el.num === reseau.num);
    if (find) reseau.selected = true;

    reseauParametreInitializer(reseau);
    return reseau;
  },
  rechercheReseaux: async ({ rootGetters, getters, commit, dispatch }) => {
    try {
      const dateDeVisualisation = moment(getters.dateDeVisualisation).format('YYYYMMDD');
      const azimut = rootGetters['user/afficherAzimut'];
      const user = store.getters['user/user'];
      const site = store.getters['user/site'];
      let agenceIds = [];
      if (site === 'sopa') {
        if (getters.agences.length) {
          agenceIds = getters.agences.map((agence) => agence.agenceId);
        } else { agenceIds = [user.agenceId]; }
      }
      commit(types.SET_SHOW_RESEAUX, false);
      const response = await browseReseaux(dateDeVisualisation, getters.avecConfreres,
        agenceIds, false);
      response.data = reseauxParametreInitializer(response.data);
      const alreadySelected = rootGetters['panier/reseauxTempoPanier'];
      response.data.forEach((el) => {
        el.selected = false;
      });

      for (const selectedItem of alreadySelected) {
        const reseau = response.data.find((el) => el.num === selectedItem.num);
        if (reseau) {
          reseau.selected = true;
        } else {
          response.data.push(selectedItem);
        }
      }


      let newStartDate = moment(getters.dateDeVisualisation);
      if (!newStartDate.isValid()) {
        newStartDate = moment();
      }
      let breakpoint = 'tablet';
      if (window.innerWidth >= 1216 &&
        window.innerWidth <= 1407) { // Magic constant coming from bulma
        breakpoint = 'widescreen-only';
      } else if (window.innerWidth > 1408 &&
        window.innerWidth < 1600) {
        breakpoint = 'fullhd';
      } else if (window.innerWidth >= 1600 &&
        window.innerWidth < 1800) {
        breakpoint = '1600px';
      } else if (window.innerWidth >= 1800) {
        breakpoint = '1800px';
      }

      if (specAffichage.week[breakpoint].startOf) {
        newStartDate.startOf(specAffichage.week[breakpoint].startOf);
      }
      newStartDate.startOf('isoWeek');
      const newEndDate = newStartDate.clone().add(specAffichage.week[breakpoint].size * 7 - 1, 'days');
      const newDuration = specAffichage.week[breakpoint].size * 7;
      const critere = {};
      critere.size = specAffichage.week[breakpoint].size;
      critere.unit = specAffichage.week[breakpoint].unit;
      critere.showAnnonceur = false;
      critere.weeks = specAffichage.week[breakpoint].size;
      critere.dateStart = newStartDate;
      critere.dateEnd = newEndDate;
      critere.days = newDuration;
      critere.maxReseaux = 30;
      critere.modeConsultation = false;
      commit(types.SET_CRITERE_PLANNING_TEMPO, critere);
      const { listeReseaux: result, result: propositions } =
        await getDispoReseauxTempo(response.data, newStartDate, newEndDate);
      commit(types.SET_DATA_PROPOSITION_TEMPO, propositions.data);
      commit(types.SET_RESEAUX, result);
      commit(types.TRIE_RESEAUX, getters.reseaux);
      commit(types.SET_RESEAUX_WITH_FILTER, filtrer(getters.reseaux, getters.filtresReseaux));
      commit(types.TRIE_RESEAUX, getters.reseauxWithFilter);
      commit(types.SET_MARKER_RESEAUX,
        fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, getters.reseauxWithFilter, azimut));
      commit(types.SET_CENTER_RESEAUX, defineCenter(getters.markersReseaux,
        getters.centerReseaux));
      commit(types.SET_SHOW_RESEAUX, true);

      if (getters.afficherFacesReseaux) {
        await dispatch('afficheFacesDispo');
      } else {
        return;
      }
    } catch (e) {
      gestionErreur('Erreur lors du changement de la date de debut des réseaux tempos', e);
    }
  },
  updateMarkerReseau: ({ getters, rootGetters, commit, dispatch }) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_MARKER_RESEAUX,
      fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, getters.reseauxWithFilter, azimut));
    dispatch('fromFacesReseauxToMarkers', { dispo: false });
  },
  updateMarkerReseauFilter: ({ rootGetters, commit, dispatch }, reseaux) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_MARKER_RESEAUX,
      fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX, reseaux, azimut));
    dispatch('fromFacesReseauxToMarkers', { dispo: false });
  },
  fromFacesReseauxToMarkers: ({ getters, rootGetters, commit }, payload) => {
    const allFaces = [];
    const azimut = rootGetters['user/afficherAzimut'];
    getters.reseauxWithFilter.forEach((reseau) => {
      const resultFilter = filterLatLng(reseau.listeFaces);
      const faces = resultFilter.goodList;
      faces.forEach((face) => {
        face.selected = reseau.selected;
        if (reseau.couleur) {
          face.color = reseau.couleur;
        }
        face.libelleReseau = reseau.libelle;
        if (payload.dispo) {
          if (face.dispo === 3) allFaces.push(face);
        } else {
          allFaces.push(face);
        }
      });
    });
    commit(types.SET_MARKER_FACES_DE_RESEAUX, fromTypeToMarkers(FACES_FROM_VENTES_RESEAUX,
      allFaces, azimut));
  },
  envoyerCouleurReseau: async ({ dispatch }, payload) => {
    try {
      await sendColor(payload.reseau.num, payload.couleur);
      dispatch('updateMarkerReseau');
    } catch (e) {
      gestionErreur(`Erreur lors de l'envoi de la couleur du reseau tempo n°${payload.reseau.num}`, e);
    }
  },
  async changementDateDebutPlanningTempo({ getters, commit }, payload) {
    let newStartDate = payload.debut;
    if (!newStartDate.isValid()) {
      newStartDate = moment();
    }
    let breakpoint = 'tablet';
    if (window.innerWidth >= 1216 &&
      window.innerWidth <= 1407) { // Magic constant coming from bulma
      breakpoint = 'widescreen-only';
    } else if (window.innerWidth > 1408 &&
      window.innerWidth < 1600) {
      breakpoint = 'fullhd';
    } else if (window.innerWidth >= 1600 &&
      window.innerWidth < 1800) {
      breakpoint = '1600px';
    } else if (window.innerWidth >= 1800) {
      breakpoint = '1800px';
    }

    if (specAffichage.week[breakpoint].startOf) {
      newStartDate.startOf(specAffichage.week[breakpoint].startOf);
    }
    newStartDate.startOf('isoWeek');
    const newEndDate = newStartDate.clone().add(specAffichage.week[breakpoint].size * 7 - 1, 'days');
    const newDuration = specAffichage.week[breakpoint].size * 7;
    const critere = {};
    critere.size = specAffichage.week[breakpoint].size;
    critere.unit = specAffichage.week[breakpoint].unit;
    if (Object.prototype.hasOwnProperty.call(payload, 'showAnnonceur')) {
      critere.showAnnonceur = payload.showAnnonceur;
    } else {
      critere.showAnnonceur = getters.criterePlanning.showAnnonceur;
    }
    critere.weeks = specAffichage.week[breakpoint].size;
    critere.dateStart = newStartDate;
    critere.dateEnd = newEndDate;
    critere.days = newDuration;
    critere.maxReseaux = 30;
    critere.modeConsultation = false;
    let resNums = null;
    if (Object.prototype.hasOwnProperty.call(payload, 'resNums')) {
      resNums = payload.resNums;
    } else {
      resNums = getters.reseauxWithFilter.slice(0, critere.maxReseaux).map((el) => el.num);
    }
    commit(types.SET_CRITERE_PLANNING_TEMPO, critere);
    const response = await getPropositions(
      critere.dateStart.format('YYYYMMDD'),
      critere.dateEnd.format('YYYYMMDD'),
      resNums);
    commit(types.SET_DATA_PROPOSITION_TEMPO, response.data);
  },
  ajoutFiltresDynamiquesVentesReseaux: ({ getters, commit }, payload) => {
    if (!getters.filtresDynamiquesReseaux.find((el) => {
      return el.id === payload.valueProperty.id;
    })) {
      const prop = payload.valueProperty;
      commit(types.SET_UPDATE_FILTRE, payload);
      prop.valeur = (GetListeElementUniqueParPropriete(getters.reseaux,
        payload.valueProperty.id));
      commit(types.ADD_FILTER_DYNAMIQUE, prop);
    }
  },
  gestionFiltresVentesReseaux: async ({ getters, rootGetters, commit, dispatch }) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_FILTER_CHANGED);
    commit(types.SET_RESEAUX_WITH_FILTER, filtrer(getters.reseaux, getters.filtresReseaux));
    commit(types.SET_MARKER_RESEAUX, fromTypeToMarkers(RESEAU_FROM_VENTES_RESEAUX,
      getters.reseauxWithFilter, azimut));
    await dispatch('changementDateDebutPlanningTempo',
      {
        debut: getters.criterePlanning.dateStart,
        nombreSemaines: getters.criterePlanning.weeks,
      },
      getters.markersReseaux);
    dispatch('fromFacesReseauxToMarkers', { dispo: false });
    commit(types.SET_SELECTED_MARKER_RESEAUX, '');
  },
  async gestionPanier({ getters, rootGetters, dispatch, commit }, payload) {
    const produit = rootGetters['panier/reseauxTempoPanier'].find(produit =>
      produit.num === payload.resNum &&
      produit.extensionOpportunite.annee === payload.annee &&
      produit.extensionOpportunite.semaine === payload.semaine);
    const dateDeVisualisation = moment(`${payload.annee}-${payload.semaine}`, 'GGGG-WW').endOf('week').format('YYYYMMDD');
    if (produit) {
      dispatch('suppressionDuPanier', produit);
      if ((getters.poseOption === OPTION && produit.extensionOpportunite.demande !== OPTION)
        || (getters.poseOption === BLOQUE && produit.extensionOpportunite.demande !== BLOQUE)
        || (getters.poseOption === SELECTION
          && produit.extensionOpportunite.demande !== SELECTION)) {
        const reseauTempo = await dispatch('getReseau', { id: payload.resNum, dateDeVisualisation });
        await dispatch('ajoutAuPanier', {
          reseauTempo: reseauTempo,
          semaine: payload.semaine,
          annee: payload.annee,
          dataPropositions: payload.dataPropositions,
        });
      }
    } else {
      const reseauTempo = await dispatch('getReseau', { id: payload.resNum, dateDeVisualisation });
      await dispatch('ajoutAuPanier', {
        reseauTempo: reseauTempo,
        semaine: payload.semaine,
        annee: payload.annee,
        dataPropositions: payload.dataPropositions,
      });
    }
    commit('panier/' + typesPanier.TRIE_PRODUIT_TYPE_RESEAU_TEMPO, null, { root: true });
  },
  async ajoutAuPanier({ commit, dispatch, getters }, payload) {
    let reseauTempoAAjouter = Object.assign({}, payload.reseauTempo);
    await reseauDataPropositionInitializer(reseauTempoAAjouter,
      payload.semaine, payload.annee, payload.dataPropositions);
    if (!reseauTempoAAjouter.dataProposition) {
      gestionErreur(`Il n'y a aucune tarification pour le réseau "${reseauTempoAAjouter.libelle}" à cette date`);
      return;
    }
    // debut - récupération des faces du réseau à la semaine demandé
    const query = {
      params: {
        dateVisualisation: getDateByJourAnneeSemaine(reseauTempoAAjouter.jourDepart + 1,
          payload.annee, payload.semaine).format('YYYYMMDD'),
        anneeSemaine: getAnneeSemaine(payload.annee, payload.semaine),
        jourDepart: reseauTempoAAjouter.jourDepart,
        societeId: reseauTempoAAjouter.socCode,
        selectionFaceForOption: getters.poseOption === OPTION,
      },
    };
    const faces = await getFacesReseauAsync(
      reseauTempoAAjouter.num,
      query,
      reseauTempoAAjouter.listeFaces,
    );
    reseauTempoAAjouter.listeFaces = faces;
    // fin
    reseauTempoAAjouter = await reseauTempoExtensionInitializer(reseauTempoAAjouter,
      payload.semaine, payload.annee);
    reseauTempoAAjouter.selected = false;
    if (reseauTempoAAjouter.extensionOpportunite.masquerFaceEdition === undefined) {
      reseauTempoAAjouter.extensionOpportunite.masquerFaceEdition = false;
    }
    if (reseauTempoAAjouter.extensionOpportunite.visualiserCarteEdition === undefined) {
      reseauTempoAAjouter.extensionOpportunite.visualiserCarteEdition = true;
    }
    if (!reseauTempoAAjouter.extensionOpportunite.demande) {
      if (getters.poseOption === OPTION) {
        reseauTempoAAjouter.extensionOpportunite.demande = OPTION;
      } else if (getters.poseOption === BLOQUE) {
        reseauTempoAAjouter.extensionOpportunite.demande = BLOQUE;
      } else if (getters.poseOption === SELECTION) {
        reseauTempoAAjouter.extensionOpportunite.demande = SELECTION;
      }
    }
    if (getters.address) {
      if (getValuePropriety(getters.address, 'libelleAdresse', '').toUpperCase() === reseauTempoAAjouter.ville.toUpperCase()) {
        adresseReseauxTempo = {
          lat: getters.address.lat,
          lng: getters.address.lng,
          nom: 'adresseReseauxTempo',
        };
      }
    }
    commit('panier/' + typesPanier.ADD_PRODUIT_TYPE_RESEAU_TEMPO, reseauTempoAAjouter, { root: true });
    commit('panier/' + typesPanier.ADD_ADRESSES_PRODUITS, adresseReseauxTempo, { root: true });
    dispatch('panier/genererMarkerFaceReseauxTempo', null, { root: true });
  },
  suppressionDuPanier: ({ commit, dispatch }, produit) => {
    commit('panier/' + typesPanier.REMOVE_PRODUIT_TYPE_RESEAU_TEMPO, produit, { root: true });
    commit('panier/' + typesPanier.REMOVE_ADRESSES_PRODUITS, null, { root: true });
    dispatch('panier/removeReseauPersonnalise', { response: produit }, { root: true });
  },
  async afficheFacesDispo({ getters, commit, dispatch }) {
    if (getters.afficherFacesReseaux) {
      const dateDeVisualisation = moment(getters.dateDeVisualisation).format('YYYYMMDD');
      const data = getters.reseauxWithFilter;
      const reqs = [];
      const query = {
        params: {
          dateVisualisation: dateDeVisualisation,
        },
      };
      data.forEach(el => {
        query.params.anneeSemaine = getAnneeSemaineFromDate(dateDeVisualisation);
        query.params.jourDepart = el.jourDepart;
        query.params.societeId = el.socCode;
        reqs.push(getFacesReseauAsync(el.num, query, el.listeFaces));
      });
      const res = await Promise.all(reqs);
      data.forEach((el, i) => {
        if (res[i].length) {
          el.listeFaces = cloneDeep(res[i]);
        }
      });
      commit(types.SET_RESEAUX_WITH_FILTER, data);
      dispatch('fromFacesReseauxToMarkers', { dispo: true });
      return '';
    }
    await dispatch('rechercheReseaux');
    return '';
  },
  updateDataPlanning({ commit }, data) {
    commit(types.SET_DATA_PLANNING, data);
  },
  updateFiltresDynamiquesVentesReseaux: ({ getters, commit }) => {
    if (!getters.updateFiltre) return;
    if (getters.filtresDynamiquesReseaux.length === 0) return;
    getters.filtresDynamiquesReseaux.forEach(filtre => {
      if (filtre.id === getters.updateFiltre.valueProperty.id) {
        commit(types.REMOVE_FILTER_PROPERTY, getters.updateFiltre.valueProperty.id);
      }
    });
    const prop = getters.updateFiltre.valueProperty;
    prop.valeur = (GetListeElementUniqueParPropriete(getters.reseaux,
      getters.updateFiltre.valueProperty.id));
    commit(types.ADD_FILTER_DYNAMIQUE, prop);
  },
};

const getters = {
  reseaux: (state) => {
    return state.reseaux;
  },
  reseauxWithFilter: (state) => {
    return state.reseauxWithFilter;
  },
  showReseaux: (state) => {
    return state.showReseaux;
  },
  dateDeVisualisation: (state) => {
    return state.dateDeVisualisation;
  },
  markersReseaux: (state) => {
    return state.markersReseaux;
  },
  markersFacesParReseaux: (state) => {
    return state.markersFacesParReseaux;
  },
  zoomCartoReseaux: (state) => {
    return state.zoomCartoReseaux;
  },
  criterePlanning: (state) => {
    return state.criterePlanning;
  },
  dataPropositions: (state) => {
    return state.dataPropositions;
  },
  selectedMarkerFacesDeReseaux: (state) => {
    return state.selectedMarkerFacesDeReseaux;
  },
  selectedMarkerReseaux: (state) => {
    return state.selectedMarkerReseaux;
  },
  centerReseaux: (state) => {
    return state.centerReseaux;
  },
  avecConfreres: (state) => {
    return state.avecConfreres;
  },
  isochrone: (state) => {
    return state.isochrone;
  },
  typeLayerGeoMarketing: (state) => {
    return state.typeLayerGeoMarketing;
  },
  filtresReseaux: (state) => {
    return state.filtresReseaux;
  },
  filtresDynamiquesReseaux: (state) => {
    return state.filtresDynamiquesReseaux;
  },
  filtresDynamiquesReseauxSpe: (state) => (id) => {
    return state.filtresDynamiquesReseaux.find((el) => { return el.id === id; });
  },
  filterReseauxChanged: (state) => {
    return state.filterReseauxChanged;
  },
  selectedFiltreDynamiqueReseaux: (state) => {
    return state.selectedFiltreDynamiqueReseaux;
  },
  activeTabReseau: (state) => {
    return state.activeTabReseau;
  },
  zoomMarker: (state) => {
    return state.zoomMarker;
  },
  showReseauxSelectionne: (state) => {
    return state.showReseauxSelectionne;
  },
  facesReseauSelectDiapo: (state) => {
    return state.facesReseauSelectDiapo;
  },
  afficherFacesReseaux: (state) => {
    return state.afficherFacesReseaux;
  },
  filtreDispoReseau: (state) => {
    return state.filtreDispoReseau;
  },
  dataPlanning: (state) => {
    return state.dataPlanning;
  },
  pointsAddress: (state) => {
    return state.pointsAddress.filter(el => el.coordonnees);
  },
  address: (state) => {
    return state.address;
  },
  poseOption: (state) => {
    return state.poseOption;
  },
  agences: (state) => {
    return state.agences;
  },
  updateFiltre: (state) => {
    return state.updateFiltre;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/venteReseauxTempo.js